module.exports = __webpack_public_path__ + "img/main-banner-bg.8b62c085.jpg";